import UrlService from '../UrlService';

export const GMAIL_TRACKING_LOCATION = 'gmail';

const getTrackingLocation = (url?: string) => {
  if (!url) {
    return '';
  }

  const urlObject = UrlService.createEventUrl(url);

  if (UrlService.isSalesNavPage(urlObject)) {
    return 'sales navigator';
  }

  if (UrlService.isLinkedinUrl(urlObject)) {
    return 'linkedin';
  }

  if (UrlService.isGoogleCalendarUrl(urlObject)) {
    return 'Google calendar';
  }

  if (UrlService.isOutlookCalendarUrl(urlObject)) {
    return 'Outlook calendar';
  }

  if (UrlService.isSalesloftUrl(urlObject)) {
    return 'Salesloft';
  }

  if (UrlService.isHubspotUrl(urlObject)) {
    return 'crm hubspot';
  }

  if (UrlService.isSalesforceUrl(urlObject) || UrlService.isSalesforceLightningUrl(urlObject)) {
    return 'crm salesforce';
  }

  if (UrlService.isMicrosoftDynamicsUrl(urlObject)) {
    return 'crm dynamics';
  }

  if (UrlService.isGmailUrl(urlObject)) {
    return GMAIL_TRACKING_LOCATION;
  }

  if (UrlService.isGoogleSheetsUrl(urlObject)) {
    return 'google sheets';
  }

  if (UrlService.isProPage(urlObject)) {
    return 'similarweb platform';
  }

  return 'company website';
};

export default getTrackingLocation;
